import { getFiscalYear } from '../../utils/fiscalYear';
import * as types from './programActionTypes';
import { ProgramActionKeys as keys } from './programsActionKeys';
import {
  IProgram,
  IProgramCashDiscount,
  IProgramGroup,
  IProgramLevel,
  IProgramPreSeasonSetup
} from './programsInterfaces';

export const programsActionCreators = {
  deleteCashDiscount: (programCashDiscountId: number): types.DeleteCashDiscount => ({
    payload: { programCashDiscountId },
    type: keys.DELETE_CASH_DISCOUNT
  }),
  deleteProgramGroup: (programGroupId: number): types.DeleteProgramGroup => ({
    payload: { programGroupId },
    type: keys.DELETE_PROGRAM_GROUP
  }),
  deleteProgramLevel: (programLevelId: number): types.DeleteProgramLevel => ({
    payload: { programLevelId },
    type: keys.DELETE_PROGRAM_LEVEL
  }),
  fetchCashDiscounts: (fiscalYear: string): types.FetchCashDiscounts => ({
    payload: { fiscalYear },
    type: keys.FETCH_CASH_DISCOUNTS
  }),
  fetchPreseasonSetup: (fiscalYear: string): types.FetchPreSeasonProgramSetup => ({
    payload: { fiscalYear },
    type: keys.FETCH_PRESEASON_PROGRAM_SETUP
  }),
  fetchPrograms: (fiscalYear: string = getFiscalYear()): types.FetchPrograms => ({
    payload: fiscalYear,
    type: keys.FETCH_PROGRAMS
  }),
  queryCashDiscounts: (payload: { accountNum: string; fiscalYear?: string }): types.QueryCashDiscounts => ({
    payload,
    type: keys.QUERY_CASH_DISCOUNT
  }),
  removeCashDiscount: (programCashDiscountId: number): types.RemoveCashDiscount => ({
    payload: { programCashDiscountId },
    type: keys.REMOVE_CASH_DISCOUNT
  }),
  removeProgramGroup: (programGroupId: number): types.RemoveProgramGroup => ({
    payload: { programGroupId },
    type: keys.REMOVE_PROGRAM_GROUP
  }),
  removeProgramLevel: (programLevelId: number): types.RemoveProgramLevel => ({
    payload: { programLevelId },
    type: keys.REMOVE_PROGRAM_LEVEL
  }),
  setCashDiscounts: (payload: IProgramCashDiscount[]): types.SetCashDiscounts => ({
    payload,
    type: keys.SET_CASH_DISCOUNTS
  }),
  setDealerCashDiscount: (payload: {
    programCashDiscountId: number | null;
    fiscalYear: string;
    accountNum: string;
  }): types.SetDealerCashDiscount => ({
    payload,
    type: keys.SET_DEALER_CASH_DISCOUNT
  }),
  setMaxFiscal: (maxFiscal: string): types.SetMaxProgramFiscal => ({
    payload: maxFiscal,
    type: keys.SET_MAX_PROGRAM_FISCAL
  }),
  setPreSeasonSetup: (payload: IProgramPreSeasonSetup[]): types.SetPreSeasonProgramSetup => ({
    payload,
    type: keys.SET_PRESEASON_PROGRAM_SETUP
  }),
  setProgramGroups: (payload: IProgramGroup[]): types.SetProgramGroups => ({
    payload,
    type: keys.SET_PROGRAM_GROUPS
  }),
  setProgramLevels: (payload: IProgramLevel[]): types.SetProgramLevels => ({
    payload,
    type: keys.SET_PROGRAM_LEVELS
  }),
  setPrograms: (programs: IProgram[]): types.SetPrograms => ({
    payload: programs,
    type: keys.SET_PROGRAMS
  }),
  updateCashDiscount: (payload: IProgramCashDiscount): types.UpdateCashDiscount => ({
    payload,
    type: keys.UPDATE_CASH_DISCOUNT
  }),
  updatePreSeasonSetup: (payload: IProgramPreSeasonSetup): types.UpdateProgramPreSeasonSetup => ({
    payload,
    type: keys.UPDATE_PROGRAM_PRESEASON_SETUP
  }),
  updateProgramGroup: (payload: IProgramGroup): types.UpdateProgramGroup => ({
    payload,
    type: keys.UPDATE_PROGRAM_GROUP
  }),
  updateProgramLevel: (payload: IProgramLevel): types.UpdateProgramLevel => ({
    payload,
    type: keys.UPDATE_PROGRAM_LEVEL
  })
};
